<template>
  <section class="content">
   <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
     <form class="form-horizontal"  >
          <div style="margin: 0% -110% 0% 27%;">

          <div class="form-group">
              <label for="subHead"
               class="col-sm-1 control-label">Order No
               <span style="color:red">*</span>
               </label>
              <input type="text"  ref="name" class="col-sm-2 form-control input"
               v-model.trim="orderNo"  id="subHead" />
            </div>
              <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Customer Name</label>
              <input type="text"  v-model.trim="customerName"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Contact Number</label>
              <input type="text"  v-model.trim="contactNumber"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Address</label>
              <input type="text"  v-model.trim="address"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Product Name</label>
              <input type="text"  v-model.trim="productName"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Size</label>
              <input type="text"  v-model.trim="size"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Bill Amount</label>
              <input type="text"  v-model.trim="billAmount"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
            <div class="form-group">
              <label for="shortName"
              class="col-sm-1 control-label">Remarks</label>
              <input type="text"  v-model.trim="remarks"
               class="col-sm-2 form-control input" id="shortName" />
            </div>
 <div style="margin: 0% 0% 0% 8%;">
        <button type="submit" class="btn btn-primary pull-left" id="action" @click.prevent="addItemToDTO">
                  {{'Add'}}</button>
          <button  class="btn btn-danger pull-left" style="margin: 0% 0% 0.5% 1%;"
            @click.prevent="reset()">Re-set</button>
            <button type="submit" class="btn btn-success pull-left"    style="margin: 0% 0% 0% 18%;"  id="action" @click.prevent="exportToPdf()">
                  {{'Print'}}</button>
                  <!-- <button type="submit" class="btn btn-success pull-left"    style="margin: 0% 0% 0% 18%;"  id="action" @click.prevent="exportToPdf1()">
                  {{'Print 1'}}</button> -->
                  <button type="submit" style="margin: 0% 0% 0% 1%" class="btn btn-danger pull-left" id="action" @click.prevent="resetPrint()">
                  {{'Rest Print'}}</button>
        </div>

          </div>
          <div class="container-fluid">
          <div class="row">
            <!-- <div class="scrollable"> -->
              <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Order No</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Contact Number</th>
                    <th scope="col">Address</th>
                    <th scope="col">Product Name</th>
                    <th scope="col">Size</th>
                    <th scope="col">Bill Amount</th>
                    <th scope="col">Renarks</th>
                  </tr>
                </thead>
                <tbody  v-for="(item,index) in printLists " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{item.orderNo}}</td>
                    <td>{{item.customerName}}</td>
                    <td>{{item.contactNumber}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.productName}}</td>
                    <td>{{item.size}}</td>
                    <td>{{item.billAmount}}</td>
                    <td>{{item.remarks}}</td>
                    <!-- <td>
                      <Button type="button" class="btn btn-success" @click.prevent="editFromDto(item,index)">
                          <i class="fa fa-edit"  />
                      </Button>&nbsp;&nbsp;
                      <Button class="btn btn-danger" v-if="editDto" @click="deleteItemFromDTO(item, index)" disabled>
                          <i class="fa fa-close (alias)" />
                      </Button>
                      <Button class="btn btn-danger" v-else-if="!editDto" @click="deleteItemFromDTO(item, index)" >
                            <i class="fa fa-close (alias)" />
                          </Button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          <!-- </div> -->


        </div>
        </form>
    </div>
  </div>
  <!-- <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/> -->
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'

export default {
  name: 'purchaseInvoiceReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      // purchaseInvoiceLists: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      orderNo: '',
      customerName: '',
      contactNumber: '',
      address: '',
      productName: '',
      size: '',
      remarks: '',
      billAmount: '',
      printLists: [],
      printLists1: [],
      idForPrint: ''
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  computed: {
    purchaseInvoiceLists() {
      return this.$store.state.purchase.purchaseInvoiceLists
    }
  },
  methods: {
    async searchInvoice() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadpurchaseInvoiceLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry! No data available.', life: 10000})
        // this.purchaseInvoiceLists = []
      }
    },
    async addItemToDTO() {
      let response = ''
      this.printLists1 = []
      if (this.orderNo === '') {
        this.orderNo = '-'
      }
      if (this.customerName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Enter Customer Name.', life: 10000})
        return
      }
      if (this.contactNumber === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Enter Contact Number.', life: 10000})
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Enter Address.', life: 10000})
      }
      if (this.productName === '') {
        this.productName = '-'
      }
      if (this.size === '') {
        this.size = '-'
      }
      if (this.remarks === '') {
        this.remarks = '-'
      }
      if (this.billAmount === '') {
        this.billAmount = '-'
      }
      if (this.printLists.length === 4) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry! cannot print more then 4.', life: 10000})
        return
      }
      let data = {
        orderNo: this.orderNo,
        customerName: this.customerName,
        contactNumber: this.contactNumber,
        address: this.address,
        productName: this.productName,
        size: this.size,
        remarks: this.remarks,
        billAmount: this.billAmount
      }
      this.printLists.push({...data})
      this.printLists1.push({...data})
      let print = {
        posPrintDTOList: this.printLists1
      }
      response = await this.$store.dispatch('addPrint', print)
      this.idForPrint = this.idForPrint + ',' + response.data.data
      this.printLists1 = []
      // this.reset()
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        purchaseDate: data.purchaseSalesDateNepali,
        billNo: data.billNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum
      }
      this.$router.push({name: 'purchase Detail Report', params: { purchaseHeaderObj: PIHdata }})
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'purchaseInvoice.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf() {
      // const posPrintDTOList = this.printLists
      axios({
        url: globalKey + '/fileDownload/posPrintByList/' + 'zorbi' + '/' + this.$store.getters.organisationId + '/' +
        this.$store.getters.userId + '/' + this.idForPrint,
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = this.customerName + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idForPrint = ''
    },
    exportToPdf1() {
      // const posPrintDTOList = this.printLists
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
        this.$store.getters.userId + '/' + '115,116,117',
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No 115,116,117' + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idForPrint = ''
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async editPurchaseInvoice(data) {
      let isEditData = {
        edit: data
      }
      this.$router.push({name: 'Purchase Invoice', params: { purchaseInvoice: isEditData }})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryInHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseInvoice', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.orderNo = ''
      this.customerName = ''
      this.contactNumber = ''
      this.productName = ''
      this.size = ''
      this.remarks = ''
      this.billAmount = ''
      this.address = ''
    },
    resetPrint() {
      this.printLists = []
      this.idForPrint = ''
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    cancel() {
      this.customerName = ''
      this.contactNumber = ''
      this.productName = ''
      this.size = ''
      this.remarks = ''
      this.orderNo = ''
      this.billAmount = ''
      this.address = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// printPage.vue?41f149a1